module.exports = function() {
  return new Worker(__webpack_public_path__ + "graph.worker.d2a07999.worker.js");
};